import actionTypes from '../actions/otaBill/actionType';

const initialState = {
  otaBillListLoading: false,
  otaBillList: [],
  otaBillTotal: 0,
  otaOrderListLoading: false,
  otaOrderList: [],
  otaOrderTotal: 0,
  billItemInfoLoading: false,
  billItemInfo: {},
  billItemListLoading: false,
  billItemList: [],
  billItemTotal: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_OTA_BILL_LIST_LOADING:
      const { otaBillListLoading } = payload;
      return {
        ...state,
        otaBillListLoading,
      };
    case actionTypes.INIT_OTA_BILL_LIST:
      const { otaBillList } = payload;
      return {
        ...state,
        otaBillList,
      };
    case actionTypes.SET_OTA_BILL_LIST_TOTAL:
      const { otaBillTotal } = payload;
      return {
        ...state,
        otaBillTotal,
      };
    case actionTypes.SET_OTA_ORDER_LIST_LOADING:
      const { otaOrderListLoading } = payload;
      return {
        ...state,
        otaOrderListLoading,
      };
    case actionTypes.INIT_OTA_ORDER_LIST:
      const { otaOrderList } = payload;
      return {
        ...state,
        otaOrderList,
      };
    case actionTypes.SET_OTA_ORDER_LIST_TOTAL:
      const { otaOrderTotal } = payload;
      return {
        ...state,
        otaOrderTotal,
      };
    case actionTypes.SET_BILL_ITEM_INFO_LOADING:
      const { billItemInfoLoading } = payload;
      return {
        ...state,
        billItemInfoLoading,
      };
    case actionTypes.INIT_BILL_ITEM_INFO:
      const { billItemInfo } = payload;
      return {
        ...state,
        billItemInfo,
      };
    case actionTypes.SET_BILL_ITEM_LIST_LOADING:
      const { billItemListLoading } = payload;
      return {
        ...state,
        billItemListLoading,
      };
    case actionTypes.INIT_BILL_ITEM_LIST:
      const { billItemList } = payload;
      return {
        ...state,
        billItemList,
      };
    case actionTypes.SET_BILL_ITEM_LIST_TOTAL:
      const { billItemTotal } = payload;
      return {
        ...state,
        billItemTotal,
      };
    default:
      return state;
  }
};
